module.exports = __webpack_public_path__ + "img/HAIRDRYER_AMENITY.00e82b4c.svg";